import { useSelector } from 'react-redux';
/* eslint-disable no-unused-vars */
import React from 'react';
import * as S from '../ChooseApps.styled';
import Hightlighter from 'react-highlight-words';
import { ArrowDown, ArrowRightForSelectedGroup, CheckTree } from 'assets/icons';
import { Checkbox } from 'components';
import { useEffect } from 'react';

const ItemComponent = ({ app, isAppSelected, toggleSelectedApps, search, appsSelectedData$ }) => {
  const showAppName = useSelector((state) => state.auth.show_app_name);
  return (
    <S.ChooseItemRow>
      <S.Wrap>
        <CheckTree />
        <Checkbox
          id={`checkbox-${app.pba_number}`}
          isChecked={isAppSelected(app.pba_number)}
          name={(showAppName ? app.pba_name : app.pba_number) ?? ''}
          style={{ marginRight: '16px' }}
          onChange={() => {
            toggleSelectedApps(app.pba_number);
            appsSelectedData$.value = [...appsSelectedData$.value, app];
          }}
        />
        <S.ItemName>
          <Hightlighter
            textToHighlight={showAppName ? app.pba_name ?? '' : `App ID: ${app.pba_number ?? ''}`}
            searchWords={[search]}
            highlightTag='strong'
          />
        </S.ItemName>
      </S.Wrap>
      {showAppName && (
        <S.ItemNameMarker>
          <span>App ID:</span>
          <span>{app.pba_number}</span>
        </S.ItemNameMarker>
      )}
    </S.ChooseItemRow>
  );
};

export default ItemComponent;
